export default "__VITE_ASSET__WE6nPDMT__"